import * as ActionTypes from "../constants/actionTypes"
import { ALL } from "../constants"

function init() {
	return ALL
}

export const doctorSelectionReducer = (state: string = init(), action: any): string => {
	switch (action.type) {
		case ActionTypes.UPDATE_CONSULT_PAGE_DOCTOR_TYPE_SELECTION:
			return action.payload
		default:
			return state
	}
}
